module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('SectionLabel', {
    attrs: {
      "label": _vm.trads.label
    }
  }), _vm._v(" "), (_vm.loading) ? _c('Loader', {
    attrs: {
      "loading": true
    }
  }) : _vm._e(), _vm._v(" "), _c('section', [_vm._l((_vm.references), function(reference, i) {
    return _c('label', {
      key: reference.id,
      style: ({
        order: i * 2
      }),
      attrs: {
        "for": ("reference-" + (reference.id))
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$tradFor(reference.terms.name)) + "\n        ")])
  }), _vm._v(" "), _vm._l((_vm.references), function(reference, i) {
    return _c('input', {
      key: reference.id,
      style: ({
        order: i * 2 + 1
      }),
      attrs: {
        "type": "text",
        "id": ("reference-" + (reference.id))
      },
      domProps: {
        "value": _vm.value[reference.id]
      },
      on: {
        "input": function (e) { return _vm.change(reference.id, e.target.value); }
      }
    })
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11934840","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/component-form/form-references.vue
// module id = 3021
// module chunks = 0